// removed by extract-text-webpack-plugin
module.exports = {"block":"_1VYq0E_4c3Osot6budsI99","map":"_3qRmgVbGNXA4OjyvwaJt_m","address":"_293vNrkZInmZ1BH4b7F6CA","icon":"_2GLDBeHr0Czv8yhHtktLli","marker":"_1eAmCpSeRL0xU0GQRo9OWk","iconDone":"_3U3OuGw6PBTZP08dx0mnXj","label":"_3cpaikp3S6U8aKTv0bcT3_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MapBlock/MapBlock.module.scss
// module id = 786
// module chunks = 0